import MSwitch from './Switch.vue';

export default MSwitch;
